(async function (window) {
  if (!('dataLayer' in window)) return;

  let products = document.querySelectorAll('.ecomm--product'),
    productDetail = document.querySelectorAll('.ecomm--detail'),
    addToCart = document.querySelectorAll('.ecomm--add'),
    purchased = document.querySelectorAll('.ecomm--purchase'),
    order = document.querySelector('.ecomm--order'),
    checkoutForm = document.querySelectorAll('form.ecomm--checkout'),
    cartForm = document.querySelectorAll('.cartform form'),
    cartList = document.querySelector('.cartlist'),
    cartFormItems = document.querySelectorAll('.cartform .cartlist__item'),
    cartFormAmount = document.querySelectorAll('.cartform .cartlist__item input'),
    currency = document.documentElement.dataset.currency;

  function Utility() {
    return {
      getDataAttr: (el, attr) => {
        if (!el) return false;
        return el.getAttribute('data-' + attr);
      },
      getNewPayload: () => {
        return {
          'ecommerce': {
            'currencyCode': currency
          }
        };
      }
    };
  }

  const Util = new Utility();

  /**
   * Products click tracking
   */
  (function (Util, payload, items, window) {
      payload._event = payload.event = 'productClick';

      items.forEach(function (item) {
        item.addEventListener('click', function (e) {
          //e.preventDefault();

          payload.ecommerce.click = {
            products: [{
              'name': Util.getDataAttr(item, 'name'),
              'id': Util.getDataAttr(item, 'id'),
              'price': Util.getDataAttr(item, 'price'),
              'brand': Util.getDataAttr(item, 'brand'),
              'category': Util.getDataAttr(item, 'category'),
              'position': Util.getDataAttr(item, 'pos')
            }]
          };

          payload.eventCallback = function () {
            //window.location.href = item.href;
          };

          payload.eventTimeout = 2000;

          window.dataLayer.push(payload);

        }, false);
      });
    }
  )
  (Util, Util.getNewPayload(), products, window);


  /**
   * Product view details
   */
  (function (Util, payload, items, window) {
      payload.event = 'productDetail';

      payload.ecommerce.detail = {
        value: Util.getDataAttr(items[0], 'price'),
        products: []
      };

      items.forEach(function (item) {
        payload.ecommerce.detail.products = [{
          'name': Util.getDataAttr(item, 'name'),
          'item_name': Util.getDataAttr(item, 'name'),
          'id': Util.getDataAttr(item, 'id'),
          'item_id': Util.getDataAttr(item, 'id'),
          'price': Util.getDataAttr(item, 'price'),
          'brand': Util.getDataAttr(item, 'brand'),
          'category': Util.getDataAttr(item, 'category')
        }];

        window.dataLayer.push(payload);
      });
    }
  )
  (Util, Util.getNewPayload(), productDetail, window);


  /**
   * Product add to cart tracking
   */
  (function (Util, payload, items, window) {
      payload._event = payload.event = 'addToCart';

      let clicked = {};

      items.forEach(function (item) {
        item.addEventListener('click', function (e) {
          //e.preventDefault();

          if (clicked[Util.getDataAttr(item, 'id')]) return;

          payload.ecommerce.add = {
            'value': Util.getDataAttr(item, 'price'),
            products: [{
              'name': Util.getDataAttr(item, 'name'),
              'item_name': Util.getDataAttr(item, 'name'),
              'id': Util.getDataAttr(item, 'id'),
              'item_id': Util.getDataAttr(item, 'id'),
              'price': Util.getDataAttr(item, 'price'),
              'brand': Util.getDataAttr(item, 'brand'),
              'category': Util.getDataAttr(item, 'category'),
              'quantity': 1
            }]
          };

          payload.eventCallback = function () {
            //document.location = item.href;
          };

          window.dataLayer.push(payload);

          clicked[Util.getDataAttr(item, 'id')] = true;
        }, false);
      });
    }
  )
  (Util, Util.getNewPayload(), addToCart, window);


  /**
   * Product add/remove cart form tracking
   */
  /*
  (function(Util, window.dataLayer, form, values) {
      if(!window.dataLayer) return;

      let origQuantity = [],
          addPayload = Util.getNewPayload(),
          removePayload = Util.getNewPayload(),
          submitted = 0,
          currentForm = null;

      values.forEach(quantity => {
          origQuantity[quantity.name] = parseInt(quantity.value);
      });

      addPayload._event = addPayload.event = 'addToCart';
      addPayload.ecommerce.add = {
          products: []
      };

      removePayload._event = removePayload.event = 'removeFromCart';
      removePayload.ecommerce.remove = {
          products: []
      };

      removePayload.eventCallback = addPayload.eventCallback = () => {
          submitted++;
          if(submitted == 2) currentForm.submit();
      };

      form.length && form[0].addEventListener('submit', e => {
          e.preventDefault();

          currentForm = form[0];

          values.forEach(quantity => {
              let quantityValueOrigin = origQuantity[quantity.name],
                  quantityValue = parseInt(quantity.value),
                  parent = quantity.parentNode.parentNode;

              if(quantityValue < quantityValueOrigin) {
                  removePayload.ecommerce.remove.products.push({
                      'name': Util.getDataAttr(parent, 'name'),
                      'id': Util.getDataAttr(parent, 'id'),
                      'price': Util.getDataAttr(parent, 'price'),
                      'brand': Util.getDataAttr(parent, 'brand'),
                      'category': Util.getDataAttr(parent, 'category'),
                      'quantity': (quantityValueOrigin - quantityValue)
                  });
              } else if(quantityValue > quantityValueOrigin) {
                  addPayload.ecommerce.add.products.push({
                      'name': Util.getDataAttr(parent, 'name'),
                      'id': Util.getDataAttr(parent, 'id'),
                      'price': Util.getDataAttr(parent, 'price'),
                      'brand': Util.getDataAttr(parent, 'brand'),
                      'category': Util.getDataAttr(parent, 'category'),
                      'quantity': (quantityValue - quantityValueOrigin)
                  });
              }
          });

          if(values.length) {
              window.dataLayer.push(addPayload);
              window.dataLayer.push(removePayload);
          }

          setTimeout(function() {
              currentForm.submit();
          }, 1500);

          return false;
      }, false);

  })(Util, window.dataLayer, cartForm, cartFormAmount);

   */

  /**
   * Checkout
   */
  (function (Util, payload, form, items, cartlist, window) {
      let origQuantity = [],
        currentForm = null;

      payload._event = payload.event = 'checkout';

      payload.ecommerce.checkout = {
        actionField: {'step': 1, 'option': 'Checkout'},
        value: Util.getDataAttr(cartList, 'total'),
        products: []
      };

      /*payload.eventCallback = () => {
          currentForm.submit();
      }*/

      if (form.length && form[0].className.match('ecomm--checkout')) {
        items.forEach(item => {
          payload.ecommerce.checkout.products.push({
            'name': Util.getDataAttr(item, 'name'),
            'item_name': Util.getDataAttr(item, 'name'),
            'id': Util.getDataAttr(item, 'id'),
            'item_id': Util.getDataAttr(item, 'id'),
            'price': Util.getDataAttr(item, 'price'),
            'brand': Util.getDataAttr(item, 'brand'),
            'category': Util.getDataAttr(item, 'category'),
            'quantity': Util.getDataAttr(item, 'quantity')
          });
        });

        window.dataLayer.push(payload);
      }
    }
  )
  (Util, Util.getNewPayload(), checkoutForm, cartFormItems, cartList, window);

  /**
   * Purchase
   */
  (function (Util, payload, purchased, order, window) {
    payload.event = 'purchase';

    if (!order) return false;

    payload.ecommerce.purchase = {
      actionField: {
        'id': Util.getDataAttr(order, 'id'),                         // Transaction ID. Required for purchases and refunds.
        'affiliation': 'Store',
        'revenue': Util.getDataAttr(order, 'total'),                     // Total transaction value (incl. tax and shipping)
        'tax': Util.getDataAttr(order, 'tax'),
        'shipping': '0'
      },
      products: []
    };

    purchased.forEach(item => {
      payload.ecommerce.purchase.products.push({
        'name': Util.getDataAttr(item, 'name'),
        'item_name': Util.getDataAttr(item, 'name'),
        'id': Util.getDataAttr(item, 'id'),
        'item_id': Util.getDataAttr(item, 'id'),
        'price': Util.getDataAttr(item, 'price'),
        'brand': Util.getDataAttr(item, 'brand'),
        'category': Util.getDataAttr(item, 'category'),
        'quantity': Util.getDataAttr(item, 'quantity')
      });
    });

    window.dataLayer.push(payload);

    window.dataLayer.push({
      eposCheckoutValue: Util.getDataAttr(order, 'total'),
      eposCheckoutTransationID: Util.getDataAttr(order, 'id'),
      eposCheckoutCurrency: currency
    });

    window.eposCheckoutData = {
      eposCheckoutValue: parseFloat(Util.getDataAttr(order, 'total')),
      eposCheckoutTransationID: Util.getDataAttr(order, 'id'),
      eposCheckoutCurrency: currency
    };

  })(Util, Util.getNewPayload(), purchased, order, window);

})(window)
